import { render } from "./Statuses.vue?vue&type=template&id=b122d3ee"
import script from "./Statuses.vue?vue&type=script&lang=js"
export * from "./Statuses.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mindthegapstudio/stpancras-backstage-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__